// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1w5on","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3yeGl","obliqueLine":"membershipbadge_obliqueLine__3I2py"};